/****************************************************
 * Module Name:  addWorkersettingsModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import WorkersettingsProxy from "../../utility/proxy/worker/workersettingsProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'


export default class AddWorkersettingsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newsettingkey: this.props.editOperation
        ? this.props.sourceData.settingkey
        : "",
      newsettingvalue: this.props.editOperation
        ? this.props.sourceData.settingvalue
        : "",
      newsettingdescription: this.props.editOperation
        ? this.props.sourceData.settingdescription
        : "",

      showError: false,

      validateWorkersettingsPresentSpinner: false,
      showValidationMessage: false,
      workersettingsAvailable: true,

      settingKeyValidationError: "",
      settingValueValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      settingkey: this.props.editOperation
        ? this.props.sourceData.settingkey
        : this.state.newsettingkey,
      settingvalue: this.state.newsettingvalue,
      settingdescription: this.state.newsettingdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateWorkersettingsPresent = (workersettingsEntered) => {
    if (!workersettingsEntered || workersettingsEntered.trim() === "") return;

    this.setState({
      validateWorkersettingsPresentSpinner: true,
    });

    WorkersettingsProxy.CheckWorkersettingsAvailable(
      workersettingsEntered,
      (response) => {
        //if we got response that means workersettings is present at backend
        if (response) {
          //WorkersettingsName already present
          this.setState({
            validateWorkersettingsPresentSpinner: false,
            showValidationMessage: true,
            workersettingsAvailable: false,
          });
        } else {
          //WorkersettingsName not available, so can be used
          this.setState({
            validateWorkersettingsPresentSpinner: false,
            showValidationMessage: true,
            workersettingsAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newsettingvalue.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.workersettingsAvailable ||
        this.state.newsettingvalue.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add worker setting validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Worker Settings"
                : "Add New Worker Settings"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <Form.Label>
                        Key <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newsettingkey}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Worker Key (required)"
                          placeholder="Enter Worker key"
                          value={this.state.newsettingkey}
                          autoFocus
                          onBlur={(e) =>
                            this.validateWorkersettingsPresent(
                              this.state.newsettingkey
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newsettingkey: e.target.value,
                              showValidationMessage: false,
                              settingKeyValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Worker Key Cannot be Empty",
                            })
                          }
                          helperText={this.state.settingKeyValidationError}
                          error={
                            this.state.settingKeyValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateWorkersettingsPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.workersettingsAvailable ? (
                        <font color="green">Settings key available</font>
                      ) : (
                        <font color="red">Settings key not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Value <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Value (required)"
                        placeholder="Enter Value"
                        value={this.state.newsettingvalue}
                        onChange={(e) =>
                          this.setState({
                            newsettingvalue: e.target.value,
                            settingValueValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Value Cannot be Empty",
                          })
                        }
                        helperText={this.state.settingValueValidationError}
                        error={
                          this.state.settingValueValidationError.length > 0
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newsettingdescription}
                        onChange={(e) =>
                          this.setState({
                            newsettingdescription: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
